import Api from './api'

export async function sendFeedback(feedback: Feedback) {
  try {
    return await Api.post('/feedbacks', feedback)
  } catch (error) {
    throw new Error('Could not send bug report mail')
  }
}
